// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

//COMPONENT

class SegmentItem extends React.Component {

    componentDidMount(){

    }

    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            deleteTerm: this.props.deleteTerm
        };

        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.deleteSegment = this.deleteSegment.bind(this);
        this.pushToSegmentDetails = this.pushToSegmentDetails.bind(this);
    }

    componentDidUpdate(prevProps){
        if(this.props.deleteTerm != prevProps.deleteTerm){
            this.setState({deleteTerm: this.props.deleteTerm});
        }
    }

    toggleDropDown() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    pushToSegmentDetails(){
        this.props.history.push('/segments/' + this.props.segment.id + '?name=' + this.props.segment.name);
    }

    deleteSegment(){
        this.props.deleteItem(this.props.id);
    }

    render() {
        return (
            <div className={'segment-item float gradient'} style={{background: this.props.segment.color}}>
                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                    <div className='segment-more'> 
                        <DropdownToggle className="hidden-dropdown" >
                        </DropdownToggle>
                        <img className='segment-more-image noselect' src={require('../../../images/dotdotdot.png')} />
                    </div>

                    <DropdownMenu>
                        <DropdownItem onClick={this.deleteSegment}>{this.state.deleteTerm}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                
                <div className='segment-details' onClick={this.pushToSegmentDetails}>
                    <div >
                        <img className='segment-image noselect' src={require('../../../images/segments/' + this.props.segment.image)} />
                        <div className='segment-title'> {this.props.segment.name} </div>
                    </div>
                </div>
                
            </div>
        );
    }
}

//

SegmentItem.propTypes = {
    history: PropTypes.object.isRequired,
    segment: PropTypes.object.isRequired,
    deleteTerm: PropTypes.string.isRequired,
    deleteItem: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired
};

const hoc = withRouter(SegmentItem);

// EXPORT COMPONENT
export { hoc as SegmentItem };


// WEBPACK FOOTER //
// ./src/components/pages/Segments/SegmentItem.js